import { render, staticRenderFns } from "./VariationDetail.vue?vue&type=template&id=a34209f6&scoped=true&"
import script from "./VariationDetail.vue?vue&type=script&lang=js&"
export * from "./VariationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a34209f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/35827007/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a34209f6')) {
      api.createRecord('a34209f6', component.options)
    } else {
      api.reload('a34209f6', component.options)
    }
    module.hot.accept("./VariationDetail.vue?vue&type=template&id=a34209f6&scoped=true&", function () {
      api.rerender('a34209f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/option/VariationDetail.vue"
export default component.exports